/**
 * The text to show for a failed API call.
 *
 * FastAPI answers a handler's own `HTTPException` with `detail` as a string, but a request-body
 * validation failure (a Pydantic 422) with `detail` as an array of `{ loc, msg, type }` objects.
 * Handing that array to `toast.error` makes React try to render plain objects as children, and the
 * `<Toaster>` sits at the App root, outside the layout's error boundary, so the throw blanks the
 * page. This turns either shape into a string.
 *
 * Pydantic prefixes a validator's own message with "Value error, "; that is dropped, because it
 * describes the library rather than the problem.
 *
 * @param {object} error the rejection an `api` call throws (axios error).
 * @param {string} fallback shown when the response carries no usable detail.
 * @returns {string}
 */
export function errorDetailMessage(error, fallback) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => (typeof item === "string" ? item : item?.msg))
      .filter((msg) => typeof msg === "string" && msg)
      .map((msg) => msg.replace(/^Value error, /, ""));
    if (messages.length) return messages.join("; ");
  }
  return fallback;
}
